export const getBusinessDatesCountDATE = (startDate, endDate) => {
  let count = 0;
  let curDate = +startDate;
  while (curDate <= +endDate) {
    const dayOfWeek = new Date(curDate).getDay();
    const isWeekend = (dayOfWeek === 6) || (dayOfWeek === 0);
    if (!isWeekend) {
      count++;
    }
    curDate = curDate + 24 * 60 * 60 * 1000
  }
  return count;
}

export const getBusinessDateCountString = (startDate, endDate) => {
  if (startDate.getDate() === endDate.getDate()) {
    return 0;
  }

  let elapsed, daysBeforeFirstSaturday, daysAfterLastSunday;
  let ifThen = function (a, b, c) {
      return a === b ? c : a;
  };

  elapsed = endDate - startDate;
  elapsed /= 86400000;

  daysBeforeFirstSaturday = (7 - startDate.getDay()) % 7;
  daysAfterLastSunday = endDate.getDay();

  elapsed -= (daysBeforeFirstSaturday + daysAfterLastSunday);
  elapsed = (elapsed / 7) * 5;
  elapsed += ifThen(daysBeforeFirstSaturday - 1, -1, 0) + ifThen(daysAfterLastSunday, 6, 5);

  const calculation = Math.ceil(elapsed);
  return calculation === 0 ? 0 : (calculation - 1);
}

export const diffDays = (date_1, date_2) => {
  let difference = date_1.getTime() - date_2.getTime();
  return Math.ceil(difference / (1000 * 3600 * 24));
}
